// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';
import {
  UniversalNavProvider,
  UniversalLayoutQueryContainer,
} from '@zapier/universal-layout';

import { Account } from '@zapier/shared-entities';

const Container = props => {
  return (
    <UniversalLayoutQueryContainer>
      <UniversalNavProvider {...props} />
    </UniversalLayoutQueryContainer>
  );
};

const mapStateToProps = state => {
  return {
    currentAccountId: Account.selectors.all.currentAccountId(state),
    currentUrl: RouterSelectors.currentUrl(state) || '',
  };
};

export default connect(mapStateToProps)(Container);
